<template>
  <div id="app">
    <div class= "fhrborder">
      <!-- {{ios}} -->
      <!-- {{os}} -->
      <!-- <v-row style="margin-bottom:8px;">
        <v-spacer></v-spacer>
        <button class="langbutton"  @click="language"> <p class="margin:3px !important">{{langval}}</p></button>
      </v-row> -->
      <div v-if="ios">
      <div @click="openImage" class="fhrinline">
      <div><img class="floatright" src= "@/assets/rightarrow.png" alt=""> </div>
      <div><h3 class="fhrheader" >{{ $t("helper.header") }}</h3> </div>
        <!-- <div><h3 class="fhrheader" >How to open Airdrop</h3> </div> -->
      </div>
      <hr class="divider">
      <div class="modal"
          v-if="showModal" 
          @close="showModal = false"
      >
      <div class="modal-content">
        <span @click="openImage" class="close">&times;</span><br>
        <img src= "@/assets/ch_airdrop.png" class="ad" alt=""> 
      </div>
      </div>
      </div>
      <h3 class="fhrheader">{{ $t("helper.header2") }}</h3>
      <!-- <h3 class="fhrheader">Customer Service</h3> -->
      <div>
          EBM 0800070988<br>
          {{ $t("helper.address") }}<br>
          <hr class="divider" style="margin-bottom:0.3em;">
          Line
          <a href="https://line.me/ti/p/YzkmYxbUlW" target="_blank" >
          <div class="fhrrow">
            <div class="fhrcolumn le">
          <img src= "@/assets/line_ebm_logo.png" class="line_ebm_logo" alt="">   
          </div>
          <div class="fhrcolumn ri">
          <span style="color:black;">{{ $t("helper.service") }}<br></span>
          @ebm35
          </div>
          </div>
          </a>
      <hr class="divider">
      </div>
      <h3 class="fhrheader">{{ $t("helper.sites") }}</h3>
      <div class="scrollHospital">
        <div class="hospitalContent">
          <div v-for="hospital in hospitalNames" :key="hospital.id" class="hospitalNames" >
                {{hospital.nameChinese}}
            <hr class="divider">
          </div>
        </div>
      </div>
      <div class="center">
        <router-link class="btn" to="/questionform">{{ $t("helper.feedback") }}</router-link><br>
      </div>
      <!-- <div class='exit' @click="exit" >離開</div> -->
      <!-- <div class="center">
      <router-link class="btn" to="/payment">Pay now</router-link>
      </div>
      <div class="center">
      <router-link class="btn" to="/serviceintro">Medical CD Express</router-link>
      </div> -->
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data:function(){    
    
    const lang = localStorage.getItem('lang')   
    return{
        lang:lang,
        langval:'',
        showModal: false,
        hospitalNames:[],
        ios: false,
        os:''
    }
  },
  metaInfo() {
        return { 
            title: "FHR",
            meta: [
                { name: 'description', content:  'A Viewer Ready DICOM Device.'},
            ]
        }
    },
  created(){
      
      const language = this.$route.query.language;
      this.$i18n.locale = 'ch'
      if(language != "zh" || language == null){
        if(language != undefined){
           this.$i18n.locale = 'en'
           console.log("跑進來判斷式1-1");
        }    
      }
      else{
        this.$i18n.locale = 'ch'
        console.log("跑進來判斷式2");
      }
      console.log("url的參數:"+ language);
    // this.os = this.getMobileOperatingSystem();
    // console.log("os看起來：" + this.getMobileOperatingSystem());
    // let lang = localStorage.getItem('lang')
    // console.log('Lang看起來如何:' + lang);
    //     lang == 'en' ? this.langval = '中' : this.langval = 'EN'
    //     if(navigator.language == 'en-US'){
          
    //         if(lang =='ch'){
    //         localStorage.setItem('lang','ch')
    //         this.lang = 'ch'
    //     }else {
    //         localStorage.setItem('lang','en')
    //         this.lang = 'en'
    //     }
    //     }
    //     else{
    //     if(lang =='en'){
    //         this.$i18n.locale = 'en'
    //         localStorage.setItem('lang','en')
    //         this.lang = 'en'
    //     }else {
    //         console.log("chinese");
    //         this.$i18n.locale = 'ch'
    //         localStorage.setItem('lang','ch')
    //         this.lang = 'ch'
    //     }
    //         } 
    axios.get('https://fhrweb.ebmtech.com/net/api/Hlists')
    .then(res => this.hospitalNames=res.data)
    .catch(error=>{
      console.log(error);
    })
    let str = navigator.userAgent;
    if(navigator.platform =='MacIntel' || navigator.platform =='MacPPC' || navigator.platform =='Mac68K' ||str.includes('iPhone')||str.includes('Mac')){
      this.ios =true;
    }
  },
  watch: {
    // whenever langval changes, this function will run
    langval: function() {
      let lang = localStorage.getItem('lang')
        lang == 'en' ? this.langval = '中' : this.langval = 'EN'
        if(navigator.language == 'en-US'){
            if(lang =='ch'){
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }else {
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }
        }
        else{
            if(lang =='en'){
                this.$i18n.locale = 'en'
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }else {
            console.log("chinese");
            this.$i18n.locale = 'ch'
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }
        }
    }
  },
  methods:{
    getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        console.log(userAgent);
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    },
    openImage(){
      this.showModal=!this.showModal;
    },
    exit(){
      console.log('exit session');
    },
    language(){
      console.log(this.langval);
      if(this.langval=='EN'){
          localStorage.setItem('lang','en');
          this.langval='中'
      }
      else{
          localStorage.setItem('lang','ch');
          this.langval='EN'
      }
      if(this.os=='Android')
      window.AndroidFun.Reload();
      else
      window.location.reload()
    },
  }
}

</script>
<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
  margin-bottom: 20px;
}
.langbutton{
  float:right; margin:4px; padding:4px; border: 1px solid black; border-radius:5px;
}
.title{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.exit{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 20px;
  cursor:pointer;
}
.scrollHospital{
  height: 16em;
  width: auto;
}
.hospitalContent{
  height:16em;
  overflow:auto;
  background:#fff;
}
.hospitalNames{
  padding-bottom: 8px;
}
.line_ebm_logo{
  width: 90%;
  margin-top: 0.4em;
}
.fhrrow:after {
  content: "";
  display: table;
  clear: both;
}
.fhrborderbtm{
  margin: auto;
  width: 40%;
}
.fhrborder{
  margin: 0.5em;
  padding: 1em;
  border: 1px solid #a8a8a8;
  border-radius: .5em;
  margin: auto;
  width: 40%;
  box-sizing: border-box;
}
@media only screen and (max-width: 700px) {
  .le{ width: 20%;
}
.ri{
  margin-top: 0.4em;
  width: 80%;
}
  /* .floatright{
  float: right;
  width: 8%;
} */
.ad{
  width: 90%;
  margin-left:fit-content;
}
.fhrborder{
  margin: 0.5em;
  padding: 1em;
  border: 1px solid #a8a8a8;
  border-radius: .5em;
  margin: auto;
  width: 95%;
  box-sizing: border-box;
}
}
.fhrheader{
  color: #8edbea;
  margin-top:0.5em;
  margin-bottom:0.5em;
}
.fhrcolumn{
  float: left;
}
.le{
width: 15%;
}
.ri{
  margin-top: 0.4em;
  width: 85%;
}
.center {
  text-align: center;
  margin: auto;
  margin-top: 1em;
  width: 50%;
  border: 1px solid #8edbea;
  padding: 10px;
  border-radius: .5em;
  background-color: #8edbea ;
}

.btn{ 
  margin-top: 1em;
  text-decoration: none;
  color:white;
}
hr.divider {
  margin-top: 8px;
  border-top: 1px solid#f9f8f9;}

.fhrinline li{
  display: inline-block;
  cursor: pointer;
}
.floatright{
  float: right;
  width: 20px;
}
.closeright{
  float: right;
}
.modal {
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 50px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}
.modal-content {
  background-color: white;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  border-radius: 0.5em;
}
.close {
  padding-right: 0.5em;
  padding-top: 0.3em;
  float: right;
  color: #aaaaaa;
  font-size: 28px;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>